import { FlatTreeControl } from "@angular/cdk/tree";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";
declare var $: any;
interface Report {
  level: number;
  Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  NoOfLoans?: string;
  POS_OS?: string;
  IN_Percentage: number;
  TotalBusiness?: number;
  Avg_LTV?: number;
  Avg_Tenure?: number;
  children?: Report[];
}
interface ReportFlatNode {
  expandable: boolean;
  level: number;
  Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  NoOfLoans?: string;
  POS_OS?: string;
  IN_Percentage: number;
  TotalBusiness?: number;
  Avg_LTV?: number;
  Avg_Tenure?: number;
}
@Component({
  selector: "app-portfolio-wise",
  templateUrl: "./portfolio-wise.component.html",
  styleUrls: ["./portfolio-wise.component.scss"],
})
export class PortfolioWiseComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;

  JsonData: any[] = [];
  dataSource: any;
  SlabData: any[] = [];
  selectedBranchRow: string = "";
  selectedProductRow: string = "";
  branchNameToIdMap: { [key: string]: number } = {};
  productNameToIdMap: { [key: string]: number } = {};
  AmCharts: any;
  //Form value
  ReportType: any = "";
  SlabId: any = "";
  ToDate: any = new Date();
  Type: any = "Future_Principal";
  //div hidden show
  SlabDropdown: boolean = false;
  DataDiv: boolean = false;
  displayedColumns: string[];
  displayedColumnsModel: string[];
  DataSourceModel: any;
  selectedId: any;
  chartdata: any;
  avgdata: any;
  femaleLoans = 0;
  maleLoans = 0;
  femaleBusiness = 0;
  maleBusiness = 0;
  femalePercentage = 0;
  malePercentage = 0;
  Total_Loan = 0;
  Total_Business = 0;
  BranchId: any;
  ProductId: any;
  private _MasterService;
  displayedTreeColumns: string[];
  parentSummary: any;
  // ExpandBtn: boolean = true;
  // CollaspeBtn: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  Types: any;
  ArrTypes: Array<{ id: number; value: string }> = [
    { id: 1, value: "Branch Wise Portfolio" },
    { id: 2, value: "Product Wise Portfolio" },
    { id: 3, value: "Amount Wise Portfolio" },
    { id: 4, value: "Tenure Wise Portfolio" },
    { id: 5, value: "IRR Wise Portfolio" },
    { id: 6, value: "LTV Wise Portfolio" },
    // { id: 7, value: "Loan A/c Category Wise Portfolio" },
    { id: 8, value: "Gender Wise Portfolio" },
    { id: 9, value: "Religion Wise Portfolio" },
    { id: 10, value: "Caste Wise Portfolio" },
    { id: 11, value: "Marital Status Wise Portfolio" },
    { id: 12, value: "Profile Wise Portfolio" },
    { id: 13, value: "Nature of work Wise Portfolio" },
  ];

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  FileCheckingList: any;
  FileCheckingList1: any;
  public Math = Math;
  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar,
  ) {
    this._MasterService = MasterService;
  }
  hasChild = (_: number, node: ReportFlatNode) => node.expandable;
  treeControl = new FlatTreeControl<ReportFlatNode>(
    (node) => node.level,
    (node) => node.expandable,
  );
  private transformer = (node: Report, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      Branch_Name: node.Branch_Name,
      Product_Name: node.Product_Name,
      LoanIds: node.LoanIds,
      NoOfLoans: node.NoOfLoans,
      POS_OS: node.POS_OS,
      IN_Percentage: node.IN_Percentage,
      TotalBusiness: node.TotalBusiness,
      Avg_LTV: node.Avg_LTV,
      Avg_Tenure: node.Avg_Tenure,
      level: level,
    };
  };
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children,
  );

  dataSourceTree: any;

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Portfolio Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.ArrTypes;

    this.displayedColumnsModel = [
      "Id",
      "Application_No",
      "LoanAcNo",
      "PLoanAcNo",
      "Loan_Date",
      "Loan_Acc_Category",
      "CustomerName",
      "RelationName",
      "LoanAmount",
      "EMIAmount",
      "Loan_Tenure",
      "LTV",
      "TotalEMI_NOS",
      "EMI_DUE_NOS",
      "receved_EMI",
      "OverDUE_EMI",
      "DPD_Days",
      "Total_OverDUE_EMI__Amount",
      "Total_OverDUE_Principal_Amount",
      "overDue_Interest_AMount",
      "Panel_Intrest",
      "Other_Dues",
      "Total_EMI_AMount",
      "Total_Principal_Amount",
      "Total_Interest_AMount",
      "EMI_DUE",
      "Principal_DUE",
      "Interest_DUE",
      "Total_Recv_EMI__Amount",
      "Total_Recv_Principal_Amount",
      "Total_Recv_Interest_AMount",
      "Balance_Principle",
      "Balance_Interest",
      "FuturePrincipal",
      "FutureInterest",
      "FirstEMIDate",
      "Last_Recv_Date",
      "Last_Recv_Amount",
      "Product_Name",
      "Branch_Name",
      "Area_Name",
      "Sub_Area_Name",
      "CollectionExecutive",
      "Customer_PhoneNo",
      "Address",
    ];
  }

  onChangeReportTypes() {
    this.SlabDropdown = false;
    this.SlabId = "";
    this.Types = this.ArrTypes.find((obj: any) => {
      return obj.id == this.ReportType;
    }).value;
    switch (this.ReportType) {
      case "3":
        this.SlabDropdown = true;
        this.getSlabsList("Amount");
        break;
      case "4":
        this.SlabDropdown = true;
        this.getSlabsList("Tenure");
        break;
      case "5":
        this.SlabDropdown = true;
        this.getSlabsList("IRR");
        break;
      case "6":
        this.SlabDropdown = true;
        this.getSlabsList("LTV");
        break;
    }
  }

  onSearchBusinessData() {
    this.chartdata = null;
    this.dataSourceTree = null;
    this.DataDiv = false;
    this.branchItem = [];
    this.productItem = [];
    this.genderItem = [];
    this.maritalStatusItem = [];
    this.salesExecItem = [];
    switch (this.ReportType) {
      case "1":
        this.getReportBranchWisePortfolio();
        break;
      case "2":
        this.getReportProductWisePortfolio();
        break;
      case "3":
        this.getReportAmountWisePortfolio();
        break;
      case "4":
        this.getReportTenureWisePortfolio();
        break;
      case "5":
        this.getReportIRRWisePortfolio();
        break;
      case "6":
        this.getReportLTVWisePortfolio();
        break;
      // case "7":
      //   this.getReportLoanAccCategoryWisePortfolio();
      //   break;
      case "8":
        this.getReportGenderWisePortfolio();
        break;
      case "9":
        this.getReportReligionWisePortfolio();
        break;
      case "10":
        this.getReportCasteWisePortfolio();
        break;
      case "11":
        this.getReportMaritalStatusWisePortfolio();
        break;
      case "12":
        this.getReportProfileWisePortfolio();
        break;
      case "13":
        this.getReportNatureOfWorkWisePortfolio();
        break;
    }
  }

  getSlabsList(Slab_Type) {
    this._MasterService
      .Get__Slab_dropdown({
        Type: Slab_Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((result) => {
        this.SlabData = JSON.parse(JSON.stringify(result));
        console.log("dtaaaa", this.SlabData);
      });
  }
  totaltypewiseBranch1(type: string): number {
    if (this.dataSourceTree && this.dataSourceTree._treeControl) {
      let sum = 0;
      for (let node of this.dataSourceTree._treeControl.dataNodes) {
        if (node.level === 0) {
          sum += Number(node[type]) || 0;
        }
      }
      return sum;
    }
    return 0;
  }
  setINPercentage(
    data: any[],
    valueKey: string = "POS_OS",
    percentKey: string = "IN_Percentage",
  ) {
    // Only sum top-level nodes (ParentId === 0)
    const total = data
      .filter((x) => x.ParentId === 0 || x.level === 0)
      .reduce((sum, x) => sum + Number(x[valueKey] || 0), 0);
    data.forEach((x) => {
      if (x.ParentId === 0 || x.level === 0) {
        x[percentKey] = total
          ? ((Number(x[valueKey] || 0) / total) * 100).toFixed(2)
          : "0.00";
      } else {
        x[percentKey] = "0.00";
      }
    });
  }
  productItem: any[] = [];
  genderItem: any[] = [];
  maritalStatusItem: any[] = [];
  salesExecItem: any[] = [];
  branchItem: any[] = [];

  branchwiseDashboard(data) {
    console.log(data);
    const branchName = data.Branch_Name ? data.Branch_Name.trim() : "";
    const branchId = this.branchNameToIdMap[branchName];

    if (!branchId) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "BranchId not found for selected branch.",
        ...this.configSuccess,
      });
      return;
    }
    this.reportsService
      .BranchWise_Portfolio_Report_Dashboard({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
        BranchId: branchId,
      })
      .subscribe((res: any) => {
        // this.itemData = res.Item1
        this.productItem = res.Item2;
        this.genderItem = res.Item3;
        this.updateGenderBreakdown(res.Item3);
        this.maritalStatusItem = res.Item4;
        this.salesExecItem = res.Item5;
        console.log(this.productItem);
      });
  }
  updateGenderBreakdown(item3: any[]) {
    this.femaleLoans = 0;
    this.maleLoans = 0;
    this.femaleBusiness = 0;
    this.maleBusiness = 0;
    this.femalePercentage = 0;
    this.malePercentage = 0;
    item3.forEach((item: any) => {
      if (item.Customer_Gender === "F") {
        this.femaleLoans += Number(item.Total_Loan);
        this.femaleBusiness += Number(item.Total_Business);
        this.femalePercentage += Number(item.IN_Percentage);
      } else if (item.Customer_Gender === "M") {
        this.maleLoans += Number(item.Total_Loan);
        this.maleBusiness += Number(item.Total_Business);
        this.malePercentage += Number(item.IN_Percentage);
      }
    });
    this.Total_Loan = this.femaleLoans + this.maleLoans;
    this.Total_Business = this.femaleBusiness + this.maleBusiness;
  }
  getFemaleArc() {
    return this.Total_Loan > 0
      ? Math.round((this.femaleLoans / this.Total_Loan) * 377)
      : 0;
  }
  getMaleArc() {
    return this.Total_Loan > 0
      ? Math.round((this.maleLoans / this.Total_Loan) * 377)
      : 0;
  }

  productwiseDashboard(data) {
    console.log(data);
    const productName = data.Product_Name ? data.Product_Name.trim() : "";
    const productId = this.productNameToIdMap[productName];

    if (!productId) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "ProductId not found for selected Product.",
        ...this.configSuccess,
      });
      return;
    }
    this.reportsService
      .ProductWise_Portfolio_Report_Dashboard({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
        ProductId: productId,
      })
      .subscribe((res: any) => {
        // this.itemData = res.Item1
        this.branchItem = res.Item2;
        this.genderItem = res.Item3;
        this.updateGenderBreakdown(res.Item3);
        this.maritalStatusItem = res.Item4;
        this.salesExecItem = res.Item5;
        console.log(this.branchItem);
      });
  }

  getReportBranchWisePortfolio() {
    this.showSpinner = true;
    // this.displayedColumns = [
    //   "Id",
    //   "Branch_Name",
    //   "NoOfLoans",
    //   "POS_OS",
    //   "AvgPosPerLoan",
    //   "IN_Percentage",
    //   "Action",
    // ];
    this.displayedTreeColumns = [
      "Branch_Name",
      // "Product_Name1",
      "NoOfLoans",
      "Avg_LTV",
      "Avg_Tenure",
      "POS_OS",
      "AvgPosPerLoan",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_BranchWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        this.branchNameToIdMap = {};
        res.forEach((item: any) => {
          if (item.Branch_Name && item.BranchId) {
            this.branchNameToIdMap[item.Branch_Name.trim()] = item.BranchId;
          }
        });
        // console.log(res);
        this.setINPercentage(res, "POS_OS", "IN_Percentage");
        const parentNodes = res.filter((item: any) => item.ParentId === 0);
        this.chartdata = this.generateChartData(parentNodes);
        this.avgdata = res.filter((item: any) => item.ParentId === 0);
        this.parentSummary = this.avgdata.length > 0 ? this.avgdata[0] : null;
        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  getReportProductWisePortfolio() {
    this.showSpinner = true;
    this.displayedTreeColumns = [
      "Product_Name",
      //  "Branch_Name1",
      "NoOfLoans",
      "Avg_LTV",
      "Avg_Tenure",
      "POS_OS",
      "AvgPosPerLoan",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_ProductWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        // Build the mapping here
        this.productNameToIdMap = {};
        res.forEach((item: any) => {
          if (item.Product_Name && item.ProductId) {
            this.productNameToIdMap[item.Product_Name.trim()] = item.ProductId;
          }
        });
        //console.log(res);
        this.chartdata = res.filter((item: any) => item.ParentId === 0);
        this.parentSummary =
          this.chartdata.length > 0 ? this.chartdata[0] : null;
        this.setINPercentage(res, "POS_OS", "IN_Percentage");

        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  // getReportLoanAccCategoryWisePortfolio() {
  //   this.showSpinner = true;
  //   this.displayedColumns = [
  //     "Id",
  //     "Loan_Acc_Category",
  //     "NoOfLoans",
  //     "POS_OS",
  //     "AvgPosPerLoan",
  //     "IN_Percentage",
  //     "Action",
  //   ];
  //   this.reportsService
  //     .Report_LoanAccCategoryWisePortfolio({
  //       To: this.ToDate,
  //       LoginUserId: this.currentUser.userId,
  //       Type: this.Type,
  //     })
  //     .subscribe((res: any) => {
  //       //console.log(res);
  //       this.chartdata = res;
  //       if (res.length > 0) {
  //         this.getDataforTable(res, "Loan_Acc_Category");
  //         this.DataDiv = true;
  //       } else {
  //         this.snackBar.openFromComponent(SnackbarComponent, {
  //           data: "No data found",
  //           ...this.configSuccess,
  //         });
  //         this.DataDiv = false;
  //       }
  //       this.showSpinner = false;
  //     });
  // }
  getReportAmountWisePortfolio() {
    this.showSpinner = true;
    //console.log(this.SlabId);
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "POS_OS",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_Amount_WisePortfolio({
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res, "Amount");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  getReportTenureWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "POS_OS",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_Tenure_WisePortfolio({
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res, "Tenure");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  getReportIRRWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "POS_OS",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_IRR_WisePortfolio({
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res, "IRR");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  getReportLTVWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "POS_OS",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_LTV_WisePortfolio({
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res, "LTV");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportGenderWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = ["Id", "Gender", "NoOfLoans", "POS_OS", "Action"];

    this.reportsService
      .Report_GenderWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of gender wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "Gender");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }

  getReportReligionWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = ["Id", "Religion", "NoOfLoans", "POS_OS", "Action"];

    this.reportsService
      .Report_ReligionWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of Religion wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "Religion");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }

  getReportCasteWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = ["Id", "Cast", "NoOfLoans", "POS_OS", "Action"];

    this.reportsService
      .Report_Cast_WisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of Catse wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "Cast");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }

  getReportMaritalStatusWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "MaritalStatus",
      "NoOfLoans",
      "POS_OS",
      "Action",
    ];

    this.reportsService
      .Report_MaritalStatus_WisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of Catse wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "MaritalStatus");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }

  getReportProfileWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Customer_Profile",
      "NoOfLoans",
      "POS_OS",
      "Action",
    ];

    this.reportsService
      .Report_Profile_WisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of Catse wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "Customer_Profile");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }

  getReportNatureOfWorkWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Natureofwork",
      "NoOfLoans",
      "POS_OS",
      "Action",
    ];

    this.reportsService
      .Report_Natureofwork_WisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        Type: this.Type,
      })
      .subscribe((res: any) => {
        console.log("Result of Catse wise api call", res);

        if (res.length > 0) {
          this.chartdata = res;
          // this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
          this.getDataforTable(res, "Natureofwork");
          this.DataDiv = true;
          this.generateChartData(res);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }

        this.showSpinner = false;
      });
  }
  getDataforTree(res: any[]) {
    if (res.length === 0) {
      this.dataSourceTree = null;
      this.showSpinner = false;
      return;
    }

    // Force all numeric columns to REAL JavaScript numbers
    res.forEach((item: any) => {
      item.NoOfLoans = this.toNumber(item.NoOfLoans);
      item.POS_OS = this.toNumber(item.POS_OS);
      item.Avg_LTV = this.toNumber(item.Avg_LTV);
      item.Avg_Tenure = this.toNumber(item.Avg_Tenure);
      item.IN_Percentage = this.toNumber(item.IN_Percentage);
      item.TotalBusiness = this.toNumber(item.TotalBusiness);

      // Handle children recursively (very important for tree structure)
      if (item.children && item.children.length > 0) {
        this.convertChildrenNumbers(item.children);
      }
    });

    this.dataSourceTree = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener,
    );
    const treeData = this.unflatten(res);
    this.dataSourceTree.data = treeData;

    this.showSpinner = false;
  }

  // Helper method
  private toNumber(value: any): number {
    if (value === null || value === undefined || value === "") return 0;
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  private convertChildrenNumbers(children: any[]) {
    children.forEach((child: any) => {
      child.NoOfLoans = this.toNumber(child.NoOfLoans);
      child.POS_OS = this.toNumber(child.POS_OS);
      child.Avg_LTV = this.toNumber(child.Avg_LTV);
      child.Avg_Tenure = this.toNumber(child.Avg_Tenure);
      child.IN_Percentage = this.toNumber(child.IN_Percentage);
      child.TotalBusiness = this.toNumber(child.TotalBusiness);

      if (child.children && child.children.length > 0) {
        this.convertChildrenNumbers(child.children);
      }
    });
  }
  //    OnClickExpandAll() {
  //   this.ExpandBtn = false;
  //   this.CollaspeBtn = true;
  //   this.treeControl.expandAll();
  // }
  // OnClickCollaspeAll() {
  //   this.ExpandBtn = true;
  //   this.CollaspeBtn = false;
  //   this.treeControl.collapseAll();
  // }
  getDataforTable(res, Type) {
    console.log("Type", Type);
    var totalSum = 0;
    res.forEach((x) => {
      totalSum = totalSum + parseFloat(x.POS_OS == null ? 0 : x.POS_OS);
    });
    res.forEach((x) => {
      if (Type == "Branch") {
        x.Name = x.Branch_Name;
      } else if (Type == "Product") {
        x.Name = x.Product_Name;
      } else if (Type == "Gender") {
        x.Name = x.Gender;
      } else if (Type == "Religion") {
        x.Name = x.Religion;
      } else if (Type == "Cast") {
        x.Name = x.Cast;
      } else if (Type == "MaritalStatus") {
        x.Name = x.MaritalStatus;
      } else if (Type == "Customer_Profile") {
        x.Name = x.Customer_Profile;
      } else if (Type == "Natureofwork") {
        x.Name = x.Natureofwork;
      } else {
        x.Name = x.SlabName;
      }
      x.IN_Percentage = (
        (parseFloat(x.POS_OS == null ? 0 : x.POS_OS) / totalSum) *
        100
      ).toFixed(2);
      x.NoOfLoans = this.toNumber(x.NoOfLoans);
      x.POS_OS = this.toNumber(x.POS_OS);
      x.Avg_LTV = this.toNumber(x.Avg_LTV);
      x.Avg_Tenure = this.toNumber(x.Avg_Tenure);
      x.IN_Percentage = this.toNumber(x.IN_Percentage);
    });
    this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
    console.log("File", this.FileCheckingList1);
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));

    this.dataSource.sort = this.sort;
    //this.generateChartData(res);
    this.showSpinner = false;
  }
  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;
    let sh;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.Id] = arrElem;
      mappedArr[arrElem.Id]["children"] = [];
    }

    for (var Id in mappedArr) {
      if (mappedArr.hasOwnProperty(Id)) {
        mappedElem = mappedArr[Id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.ParentId > 0) {
          mappedArr[mappedElem["ParentId"]]["children"].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }

    return tree;
  }
  totaltypewise(type) {
    if (
      this.dataSource != null &&
      this.dataSource != undefined &&
      this.dataSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      switch (type) {
        case "NoOfLoans":
          return sum; // return as number
        case "POS_OS":
          return sum; // return as number
        case "IN_Percentage":
          return Math.round(sum); // return as number, add % in template if needed
      }
    }
    return 0;
  }
  // exportTable(exporter: any) {
  //   exporter.exportTable("xls", {
  //     fileName: `portfolio-summary`,
  //     sheet: "portfolio-summary",
  //   });
  // }

  goToDueListDetails(row) {
    this.showSpinner = true;

    this.paginator.pageIndex = 0;
    let _finalData = {
      Search: {
        DueUpto: this.ToDate,
        Type: "All",
        ReceiptUpTo: this.ToDate,
        BranchId: row.BranchId,
        LoanIds: row.LoanIds,
      },
    };

    this.reportsService
      .Get_Due_List({ JSON: JSON.stringify(_finalData), ODInterestBalance: 0 })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          res.forEach((x) => {
            x.EMIAmount = parseFloat(x.EMIAmount).toFixed(2);
          });
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          console.log("dataaa", this.FileCheckingList);
          this.DataSourceModel = new MatTableDataSource(
            JSON.parse(JSON.stringify(res)),
          );
          this.DataSourceModel.sort = this.sort;
          this.DataSourceModel.paginator = this.paginator;
          $("#ViewDueListDetails").modal("show");
          $("#ViewDueListDetails").css("z-index", "1050");
          this.showSpinner = false;
        }
      });
  }

  onCloseDueListDetails() {
    $("#ViewDueListDetails").modal("hide");
  }

  createPieChart(chartdata) {
    let data = this.generateChartData(chartdata);
    //console.log(data);
    if ($("#ampiechart2").length) {
      var chart = this.AmCharts.makeChart("ampiechart2", {
        type: "pie",
        theme: "light",
        labelRadius: -65,
        labelText: "[[title]]%",
        //"labelText": "[[percents]]%",
        dataProvider: data,
        titleField: "title",
        valueField: "value",
        export: {
          enabled: false,
        },
        color: "#fff",
      });
    }
  }

  generateChartData(data) {
    var chartData = [];
    for (var i = 0; i < data.length; i++) {
      chartData.push({
        title: data[i].Branch_Name,
        value: Number(data[i].POS_OS).toFixed(2),
      });
    }
    //console.log(chartData);
    this.chartdata = chartData;
    return chartData;
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }

  exportTableAsXLSX(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "portfolio_model",
    ) as HTMLTableElement;
    const worksheetName = "PORTFOLIO WISE DETAILS"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
  exportTable1(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `PORTFOLIO REPORT`,
      sheet: "PORTFOLIO REPORT",
    });
  }
  exportTable(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "portfolio_report",
    ) as HTMLTableElement;
    const worksheetName = "PORTFOLIO REPORT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  applyFilter(filterValue: string) {
    this.DataSourceModel.filter = filterValue.trim().toLowerCase();
  }

  exportTreeTable(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{mso-number-format:General;}</style></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    let tableHTML = `
    <tr>
      <th style="background:#4dc3a3;border:1px solid white">Name</th>
      <th style="background:#4dc3a3;border:1px solid white">No Of Loans</th>
      <th style="background:#4dc3a3;border:1px solid white">Avg LTV</th>
      <th style="background:#4dc3a3;border:1px solid white">Avg Tenure</th>
      <th style="background:#4dc3a3;border:1px solid white">POS OS</th>
      <th style="background:#4dc3a3;border:1px solid white">IN Percentage</th>
    </tr>`;

    let totalNoOfLoans = 0;
    let totalPOS = 0;
    let totalAvgLTV = 0;
    let totalAvgTenure = 0;
    let totalINPerc = 0;

    if (this.dataSourceTree && this.dataSourceTree.data) {
      this.dataSourceTree.data.forEach((node: any) => {
        const name = node.Branch_Name || node.Product_Name || "";
        const noOfLoans = Number(node.NoOfLoans) || 0;
        const avgLTV = Number(node.Avg_LTV) || 0;
        const avgTenure = Number(node.Avg_Tenure) || 0;
        const posOS = Number(node.POS_OS) || 0;
        const inPerc = Number(node.IN_Percentage) || 0;

        tableHTML += `
        <tr>
          <td>${name}</td>
          <td>${noOfLoans}</td>
          <td>${avgLTV}</td>
          <td>${avgTenure}</td>
          <td>${posOS}</td>
          <td>${inPerc}</td>
        </tr>`;

        totalNoOfLoans += noOfLoans;
        totalPOS += posOS;
        totalAvgLTV += avgLTV;
        totalAvgTenure += avgTenure;
        totalINPerc += inPerc;
      });
    }
    tableHTML += `
    <tr style="font-weight:bold">
      <td style="background:#4dc3a3; border: 1px solid black"><b>Total</b></td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalNoOfLoans}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalAvgLTV}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalAvgTenure}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalPOS}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${Math.round(totalINPerc)}</td>
    </tr>`;

    const ctx = { worksheet: "Portfolio Report", table: tableHTML };
    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = "PORTFOLIO_REPORT.xls";
    downloadLink.click();
  }
  exportNormalTable(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{mso-number-format:General;}</style></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    let tableHTML = `
    <tr>
      <th style="background:#4dc3a3;border:1px solid white">#</th>
      <th style="background:#4dc3a3;border:1px solid white">Name</th>
      <th style="background:#4dc3a3;border:1px solid white">No Of Loans</th>
      <th style="background:#4dc3a3;border:1px solid white">POS OS</th>
      <th style="background:#4dc3a3;border:1px solid white">IN Percentage</th>
    </tr>`;

    let totalNoOfLoans = 0;
    let totalPOS = 0;
    let totalINPerc = 0;

    if (this.FileCheckingList1 && this.FileCheckingList1.length > 0) {
      this.FileCheckingList1.forEach((row: any, i: number) => {
        const name =
          row.Name ||
          row.SlabName ||
          row.Gender ||
          row.Religion ||
          row.Cast ||
          row.MaritalStatus ||
          row.Customer_Profile ||
          row.Natureofwork ||
          "";

        const noOfLoans = Number(row.NoOfLoans) || 0;
        const posOS = Number(row.POS_OS) || 0;
        const inPerc = Number(row.IN_Percentage) || 0;

        tableHTML += `
        <tr>
          <td>${i + 1}</td>
          <td>${name}</td>
          <td>${noOfLoans}</td>
          <td>${posOS}</td>
          <td>${inPerc}</td>
        </tr>`;

        totalNoOfLoans += noOfLoans;
        totalPOS += posOS;
        totalINPerc += inPerc;
      });
    }

    tableHTML += `
    <tr style="font-weight:bold">
      <td colspan="2" style="background:#4dc3a3; border: 1px solid black"><b>Total</b></td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalNoOfLoans}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${totalPOS}</td>
      <td style="background:#4dc3a3; border: 1px solid black">${Math.round(totalINPerc)}</td>
    </tr>`;

    const ctx = { worksheet: "Portfolio Report", table: tableHTML };
    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = "PORTFOLIO_REPORT.xls";
    downloadLink.click();
  }
}
